/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Link, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState, useEffect, useMemo, useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';
import moment from 'moment';
import RejectAppointmentModal from './RejectAppointmentModal';
import {
  postApprovalApproved,
  getAppointments,
  getMedReps,
  getBelowTarget,
} from '../../../api/approvalsApi';
// import JustificationAppointmentModal from './JustificationAppointmentModal';
import CWPContext from '../useCWPContext';
// import AlertDialog from '../../../components/AlertDialog';

export default function ForApprovalMedRepList({ selectedYearMonth, onClickSpecialist }) {
  const { onReloadTable } = useContext(CWPContext);

  const [appointments, setAppointments] = useState({
    data: [],
    totalRows: 0,
  });
  const [selected, setSelected] = useState([]);
  const [tableData, setTableData] = useState({
    data: [],
    totalRows: 0,
    loading: false,
  });

  const [rejectModal, setRejectModal] = useState({
    toggle: false,
    data: [],
  });

  // const [justificationModal, setJustificationModal] = useState({
  //   toggle: false,
  //   data: [],
  //   selectedRow: null,
  // });

  // const [alertDialogModal, setAlertDialogModal] = useState({
  //   toggle: false,
  //   belowTargets: [],
  // });

  const loadMedReps = async () => {
    try {
      setTableData({ ...tableData, data: [], loading: true });
      const res = await getMedReps(selectedYearMonth);

      const { success, data, totalRows, message } = res.data;

      if (!success) {
        toast.error(message);
        return;
      }

      setTableData({
        ...tableData,
        data,
        totalRows,
        loading: false,
      });
    } catch (error) {
      setTableData({ ...tableData, data: [], totalRows: 0, loading: false });
      toast.error(error.message);
    }
  };

  useEffect(() => {
    loadMedReps();
  }, []);

  useEffect(() => {
    loadMedReps();
  }, [selectedYearMonth]);

  const handleMedRepApproved = async (params) => {
    try {
      toast.loading('Please wait ...');

      const res = await postApprovalApproved(params);

      toast.dismiss();

      const { success, message } = res.data;

      if (!success) {
        toast.error(message);
        return;
      }

      toast.success(message);

      loadMedReps();
      const appointmentData = { data: [], totalRows: 0 }; // reset calendar
      setAppointments({ ...appointments, ...appointmentData });
      onClickSpecialist(appointmentData);

      onReloadTable('approved');
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getSpecialistAppointment = async (row) => {
    try {
      toast.loading('Please wait...');

      const res = await getAppointments({
        approval_id: 2, // for approval
        date: selectedYearMonth,
        rep_id: row.unique_id,
        date_submitted: row.date_scheduled,
      });

      toast.dismiss();
      const { success, data, totalRows, message } = res.data;

      if (!success) {
        toast.error(message);
        return false;
      }

      return { data, totalRows };
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
      return false;
    }
  };

  const handleApprove = useCallback(
    async (row) => {
      const result = await getSpecialistAppointment(row);

      // get appointment target

      if (!result) {
        setAppointments({ ...appointments, data: [], totalRows: 0 });
        onClickSpecialist({
          data: [],
          totalRows: 0,
        });
      } else {
        setAppointments({ ...appointments, ...result });
        onClickSpecialist({ ...result, selectedRow: row });

        // toast.loading('Please wait fetching below target...');
        // const res = await getBelowTarget([
        //   {
        //     date: selectedYearMonth,
        //     rep_id: row.unique_id,
        //     date_submitted: row.date_scheduled,
        //   },
        // ]);

        // const { success, data: getBelowTargetData } = res.data;
        // toast.dismiss();

        // if (!success) {
        //   toast.error('Error processing request.');
        //   return;
        // }

        // if (getBelowTargetData?.below_targets.length) {
        //   setAlertDialogModal({
        //     ...alertDialogModal,
        //     toggle: true,
        //     belowTargets: getBelowTargetData?.below_targets,
        //   });
        // } else {
        const { isConfirmed } = await Swal.fire({
          title: 'Approvals',
          text: `Are you sure you want to approve this?`,
          icon: 'warning',
          showCancelButton: true,
        });

        if (!isConfirmed) {
          return;
        }

        handleMedRepApproved({
          cwp: [
            {
              date: selectedYearMonth,
              rep_id: row.unique_id,
              date_submitted: row.date_scheduled,
            },
          ],
          justification: '',
          appointment_ids: '',
        });
        // }
      }
    },
    [selectedYearMonth],
  );

  const handleReject = useCallback(
    async (row) => {
      const result = await getSpecialistAppointment(row);

      if (!result) {
        setAppointments({ ...appointments, data: [], totalRows: 0 });
        onClickSpecialist({
          data: [],
          totalRows: 0,
        });
      } else {
        setAppointments({ ...appointments, ...result });
        onClickSpecialist({ ...result, selectedRow: row });

        setRejectModal({ ...rejectModal, toggle: true, data: result.data });
      }
    },
    [selectedYearMonth],
  );

  const handleOnClickSpecialist = async (row) => {
    try {
      const result = await getSpecialistAppointment(row);

      if (!result) {
        setAppointments({ ...appointments, data: [], totalRows: 0 });
        onClickSpecialist({
          data: [],
          totalRows: 0,
          selectedRow: row,
        });
      } else {
        setAppointments({ ...appointments, ...result });
        onClickSpecialist({ ...result, selectedRow: row });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleSelectionChange = (selectedRow) => {
    setSelected(selectedRow);
  };

  const handleApproveAll = async () => {
    const selectedRows = tableData.data.filter((row) => selected.indexOf(row.id) !== -1);

    if (!selectedRows.length) {
      Swal.fire({
        title: 'Approvals',
        text: 'Please select record first.',
        icon: 'error',
      });
      return;
    }

    // get all below target appoiontments

    const { isConfirmed } = await Swal.fire({
      title: 'Approvals',
      text: 'Are you sure you want to approve this?',
      icon: 'warning',
      showCancelButton: true,
    });

    if (!isConfirmed) {
      return;
    }

    try {
      toast.loading('Please wait...');
      const res = await getBelowTarget(
        selectedRows.map((row) => ({
          date: selectedYearMonth,
          rep_id: row.unique_id,
          date_submitted: row.date_scheduled,
        })),
      );

      const { success } = res.data;
      toast.dismiss();

      if (!success) {
        toast.error('Error processing request.');
        return;
      }

      // if (data.below_targets.length) {
      //   setAlertDialogModal({
      //     ...alertDialogModal,
      //     toggle: true,
      //     belowTargets: data.below_targets,
      //   });

      //   // setJustificationModal({
      //   //   ...justificationModal,
      //   //   data: data.below_targets,
      //   //   selectedRow: data.cwp,
      //   //   toggle: true,
      //   // });
      // } else {
      handleMedRepApproved({
        cwp: selectedRows.map((row) => ({
          date: selectedYearMonth,
          rep_id: row.unique_id,
          date_submitted: row.date_scheduled,
        })),
        justification: '',
        appointment_ids: '',
      });
      // }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleRejectModalClose = () => {
    setRejectModal({ ...rejectModal, toggle: false, data: [] });
  };

  const handleRejectModalSuccess = () => {
    loadMedReps();

    const appointmentData = { data: [], totalRows: 0 }; // reset calendar
    setAppointments({ ...appointments, ...appointmentData });
    onClickSpecialist(appointmentData);
  };

  // const handleJustificationModalClose = () => {
  //   setJustificationModal({ ...justificationModal, toggle: false, data: [], selectedRow: [] });
  // };

  // const handleJustificationModalSuccess = () => {
  //   loadMedReps();
  //   const appointmentData = { data: [], totalRows: 0 }; // reset calendar
  //   setAppointments({ ...appointments, ...appointmentData });
  //   onClickSpecialist(appointmentData);

  //   handleJustificationModalClose();
  //   onReloadTable('below_target');
  //   onReloadTable('approved');
  // };

  const columns = useMemo(
    () => [
      {
        field: 'label',
        headerName: 'Specialist',
        flex: 1,
        renderCell: ({ row }) => (
          <Link onClick={() => handleOnClickSpecialist(row)} sx={{ cursor: 'pointer' }}>
            {row.label}
          </Link>
        ),
      },
      {
        field: 'date_scheduled',
        headerName: 'Date Submitted',
        width: 130,
        type: 'date',
        renderCell: ({ row }) => {
          if (row.date_scheduled) {
            const arrDates = row.date_scheduled.split(',');

            return moment(arrDates[0]).format('DD/MM/YYYY');
          }

          return '';
        },
      },
      {
        field: 'actions',
        headerName: 'Actions',
        minWidth: 200,
        renderCell: ({ row }) => (
          <Stack direction='row' spacing={2}>
            <Button variant='outlined' color='error' size='small' onClick={() => handleReject(row)}>
              Reject
            </Button>
            <Button
              variant='outlined'
              color='success'
              size='small'
              onClick={() => handleApprove(row)}
            >
              Approve All
            </Button>
          </Stack>
        ),
      },
    ],
    [handleApprove, handleReject, selectedYearMonth],
  );

  // const handleCloseAlertDialog = () => {
  //   setAlertDialogModal({ ...alertDialogModal, toggle: false, belowTargets: [] });
  // };

  return (
    <>
      <Link sx={{ cursor: 'pointer', float: 'right', mt: '-30px' }} onClick={handleApproveAll}>
        Approve All
      </Link>
      <div style={{ height: '550px' }}>
        <DataGrid
          rows={tableData.data}
          loading={tableData.loading}
          rowCount={tableData.totalRows}
          columns={columns}
          pageSize={50}
          checkboxSelection
          onSelectionModelChange={handleSelectionChange}
          disableSelectionOnClick
        />
      </div>

      <RejectAppointmentModal
        toggle={rejectModal.toggle}
        data={rejectModal.data}
        onClose={handleRejectModalClose}
        onSuccess={handleRejectModalSuccess}
      />

      {/* <JustificationAppointmentModal
        toggle={justificationModal.toggle}
        data={justificationModal.data}
        selectedRow={justificationModal.selectedRow}
        onClose={handleJustificationModalClose}
        onSuccess={handleJustificationModalSuccess}
      /> */}

      {/* <AlertDialog
        toggle={alertDialogModal.toggle}
        title='CWP Approval Validation'
        onClose={handleCloseAlertDialog}
      >
        <AlertDialog.Content>
          <Box sx={{ mb: 2 }}>
            Plotted Appointment is NOT equal to the Target. Please advise the Field Force to Plot
            the lacking appointment
          </Box>
          {alertDialogModal.belowTargets.map((row) => (
            <Box sx={{ fontWeight: 'bold', color: '#000' }} key={row.doctor_id}>
              {`${row.basic_info_name} ${row.appointment_stat.for_approval} out of ${row.appointment_stat.target_calls} target`}
            </Box>
          ))}
        </AlertDialog.Content>
        <AlertDialog.Footer>
          <Button onClick={handleCloseAlertDialog}>Ok</Button>
        </AlertDialog.Footer>
      </AlertDialog> */}
    </>
  );
}

ForApprovalMedRepList.propTypes = {
  selectedYearMonth: PropTypes.string.isRequired,
  onClickSpecialist: PropTypes.func.isRequired,
};
